import styles from './SkeletonLoader.module.scss';

export type TSkeletonLoaderProps = {
	height?: string;
	width?: string;
}

export const SkeletonLoader = (props: TSkeletonLoaderProps) => {
	const {
		height = '20px',
		width = '100%'
	} = props;
	return (
		<span
			style={{ height, width }}
			data-testid={'@Layout-SkeletonLoader'}
			className={styles.skeleton}
		>
		</span>
	);
}
